import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    expert_id: null,
    crm_id: null,
};

const expertSlice = createSlice({
    name: 'expert',
    initialState,
    reducers: {
        setExpertID22: (state, payload) => {
            state.expert_id = payload.payload;
        },
        setCrmId22: (state, payload) => {
            state.crm_id = payload.payload;
        },
        resetExpertState: (state) => {
            state.expert_id = null;
            state.crm_id = null
        },
    },
});

export const { setExpertID22, setCrmId22 , resetExpertState} = expertSlice.actions;

export default expertSlice.reducer;
